import { versionDate } from './versionDate';

export const environment = {
  environmentType: 'dev',
  localDomain: 'https://admin.dev.beaconconnect.app',
  apiUrl: 'https://dev.api.goadroit.com/v1',
  client_id:
    '783896173032-91afo3riksqg88mm8ffh2cjns3f0rtl6.apps.googleusercontent.com',
  microsoft_client_id: '1e22acd3-bff2-4d04-89b8-cc5349a92979',
  redirect_uri: 'https://dev.app.goadroit.com/login',
  logout_redirect_uri: 'https://dev.api.goadroit.com/logout',
  clientUrl: 'https://dev.app.goadroit.com/',
  biUrl: 'https://dev.bi.goadroit.com/client/dashboard',

   //Dispatch package env.
   dispatchUrl: 'https://dev.dispatch-api.goadroit.com/v1/dispatch',
   dispatchRidesCollection: 'dispatch/dev/read',
   dispatchAdrAdminUrl: 'https://dev.admin.goadroit.com',
   dispatchProduction: false,
   dispatchPartnerCollection: 'dev_partners',
   dispatchMapDetailsCollection: 'dispatch/dev/map_details',
   dispatchConversationsCollection: 'dev_conversations',
   rideMapZoomLevel: 13,
   cameraStatusesCollection: 'vehicles/dev/camera_status',
   isLocal: false,
   
  versionDate,
  projectName: 'adr-client',
};
